export default __webpack_public_path__ + "static/media/person-login.1d728240.png";